(function () {
  var money = function (cents) {
    return (cents / 100).toLocaleString(window.ZZ_LOCALE || 'tr-TR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' ' + (window.ZZ_CURRENCY_SYMBOL || 'TL');
  };

  /* ---------- cart drawer ---------- */
  var drawer = {
    el: null, overlay: null,
    open: function () { if (this.el) { this.el.classList.add('is-on'); this.overlay.classList.add('is-on'); document.body.style.overflow = 'hidden'; document.body.classList.add('zz-drawer-open'); } },
    close: function () { if (this.el) { this.el.classList.remove('is-on'); this.overlay.classList.remove('is-on'); document.body.style.overflow = ''; document.body.classList.remove('zz-drawer-open'); } },
    render: function (cart) {
      var root = this.el;
      if (!root) return;
      var items = root.querySelector('[data-cart-items]');
      var countEls = document.querySelectorAll('[data-cart-count]');
      var total = root.querySelector('[data-cart-total]');
      var fill = root.querySelector('[data-ship-fill]');
      var msg = root.querySelector('[data-ship-msg]');
      var threshold = parseInt(root.getAttribute('data-free-threshold') || '0', 10);

      for (var i = 0; i < countEls.length; i++) countEls[i].textContent = cart.item_count;
      if (total) total.textContent = money(cart.total_price);

      root.classList.toggle('is-empty', !cart.items.length);

      if (!cart.items.length) {
        var emptyText = root.getAttribute('data-empty-text') || 'Sepetiniz henüz boş.';
        var emptyBtnLabel = root.getAttribute('data-empty-btn-label') || 'Alışverişe başla';
        var emptyBtnUrl = root.getAttribute('data-empty-btn-url') || '/';
        items.innerHTML = '<div class="zz-drawer__empty">' +
          '<p>' + emptyText + '</p>' +
          '<a href="' + emptyBtnUrl + '" class="zz-btn zz-btn--dark">' + emptyBtnLabel + '</a>' +
        '</div>';
      } else {
        var html = '';
        cart.items.forEach(function (li) {
          html += '<div class="zz-drawer__item">' +
            '<img src="' + (li.image ? li.image + (li.image.indexOf('?') > -1 ? '&' : '?') + 'width=124' : '') + '" alt="" loading="lazy" />' +
            '<div style="flex:1;min-width:0">' +
              '<div style="font-weight:700;font-size:14px;line-height:1.3">' + li.product_title + '</div>' +
              '<div style="font-size:13px;color:var(--zz-ink-soft);font-weight:700">' +
                (li.variant_title && li.variant_title !== 'Default Title' ? li.variant_title + ' · ' : '') +
                li.quantity + ' adet · ' + money(li.final_line_price) +
              '</div>' +
            '</div>' +
            '<button type="button" class="zz-drawer__remove" data-remove-key="' + li.key + '" aria-label="Kaldır" style="border:none;background:transparent;cursor:pointer;color:var(--zz-muted);font-size:18px">✕</button>' +
          '</div>';
        });
        items.innerHTML = html;
      }

      if (threshold > 0 && fill && msg) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        fill.style.width = pct + '%';
        var remaining = Math.max(0, threshold - cart.total_price);
        msg.textContent = cart.total_price === 0
          ? money(threshold) + ' ve üzeri kargo bedava.'
          : (remaining > 0 ? money(remaining) + ' daha ekleyin, kargo bedava!' : '🎉 Tebrikler, kargonuz bedava!');
      }
    },
    fetch: function () {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); });
    },
    change: function (body) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    add: function (id, qty) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { self.fetch(); self.open(); });
    }
  };
  window.ZZDrawer = drawer;

  document.addEventListener('DOMContentLoaded', function () {
    drawer.el = document.querySelector('[data-cart-drawer]');
    drawer.overlay = document.querySelector('[data-cart-overlay]');
    if (drawer.el) drawer.fetch();
  });

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); drawer.open(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { drawer.close(); return; }
    var rm = e.target.closest('[data-remove-key]');
    if (rm) { drawer.change({ id: rm.getAttribute('data-remove-key'), quantity: 0 }); return; }

    /* quick add from cards */
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var vid = quick.getAttribute('data-quick-add');
      if (!vid) return;
      quick.disabled = true;
      var was = quick.textContent;
      quick.textContent = 'Ekleniyor…';
      drawer.add(vid, 1).then(function () { quick.disabled = false; quick.textContent = was; });
    }

    /* mobile search toggle */
    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var searchForm = document.getElementById(searchToggle.getAttribute('aria-controls'));
      var searchOpen = searchForm.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', searchOpen ? 'true' : 'false');
      if (searchOpen) searchForm.querySelector('input').focus({ preventScroll: true });
    }

    /* mobile nav toggle */
    var navToggle = e.target.closest('[data-nav-toggle]');
    if (navToggle) {
      var panel = document.getElementById(navToggle.getAttribute('aria-controls'));
      var willOpen = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (panel) {
        if (willOpen) { panel.hidden = false; panel.setAttribute('data-open', ''); }
        else { panel.hidden = true; panel.removeAttribute('data-open'); }
      }
      return;
    }
    if (!e.target.closest('.zz-mobile-nav') && !e.target.closest('[data-nav-toggle]')) {
      var openPanel = document.querySelector('.zz-mobile-nav[data-open]');
      if (openPanel) {
        openPanel.hidden = true;
        openPanel.removeAttribute('data-open');
        var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 899) {
      var openPanel = document.querySelector('.zz-mobile-nav[data-open]');
      if (openPanel) { openPanel.hidden = true; openPanel.removeAttribute('data-open'); }
      var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.close(); });

  /* ---------- gallery: cap the thumbnail column to the main image's own
     height, so extra thumbnails scroll inside it (touch/finger works
     natively via overflow-y) instead of pushing the column taller than
     the image. Measured in JS because the thumb column's natural height
     (many small squares) can exceed the image's aspect-ratio height, so
     CSS alone (flex stretch) can't reliably cap it. ---------- */
  function syncGalleryHeight() {
    var main = document.querySelector('.zz-gallery__main');
    var thumbs = document.querySelector('.zz-gallery__thumbs');
    if (!main || !thumbs) return;
    var h = main.getBoundingClientRect().height;
    if (h > 0) thumbs.style.maxHeight = h + 'px';
  }
  window.addEventListener('load', syncGalleryHeight);
  window.addEventListener('resize', syncGalleryHeight);
  document.addEventListener('DOMContentLoaded', syncGalleryHeight);

  /* ---------- product form ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;
    var variants = JSON.parse(pdp.querySelector('[data-variants-json]').textContent);
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var oldEl = pdp.querySelector('[data-price-old]');
    var saveEl = pdp.querySelector('[data-price-save]');
    var atc = pdp.querySelectorAll('[data-atc]');
    var err = pdp.querySelector('[data-size-error]');
    var qtyInput = pdp.querySelector('[data-qty]');
    var totalEls = pdp.querySelectorAll('[data-total-label]');
    var sizeLabels = pdp.querySelectorAll('[data-size-label]');
    var qtyDisplays = pdp.querySelectorAll('[data-qty-display]');

    var selected = { size: '', color: pdp.getAttribute('data-initial-color') || '' };

    var hasSizes = !!pdp.querySelector('[data-size], [data-size-select]');
    function findVariant() {
      if (!hasSizes) {
        for (var n = 0; n < variants.length; n++) if (!selected.color || variants[n].options.indexOf(selected.color) > -1) return variants[n];
        return variants[0];
      }
      if (!selected.size) return null;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (o.indexOf(selected.size) > -1 && (!selected.color || o.indexOf(selected.color) > -1)) return variants[i];
      }
      return null;
    }

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10)); }

    function showMedia(idx) {
      var imgs = pdp.querySelectorAll('[data-main-image]');
      for (var m = 0; m < imgs.length; m++) imgs[m].hidden = imgs[m].getAttribute('data-main-image') !== idx;
      var ts = pdp.querySelectorAll('[data-thumb]');
      var activeThumb = null;
      for (var t = 0; t < ts.length; t++) {
        var on = ts[t].getAttribute('data-thumb') === idx;
        ts[t].classList.toggle('is-on', on);
        if (on) activeThumb = ts[t];
      }
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function baseFileName(url) {
      if (!url) return '';
      return url.split('?')[0].split('/').pop();
    }

    function sizeAvailableForColor(sizeVal) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (o.indexOf(sizeVal) === -1) continue;
        if (selected.color && o.indexOf(selected.color) === -1) continue;
        if (variants[i].available) return true;
      }
      return false;
    }

    function updateSizeAvailability() {
      var sizeEls = pdp.querySelectorAll('[data-size]');
      for (var s = 0; s < sizeEls.length; s++) {
        sizeEls[s].disabled = !sizeAvailableForColor(sizeEls[s].getAttribute('data-size'));
      }
      var opts = pdp.querySelectorAll('[data-size-select] option');
      for (var o2 = 0; o2 < opts.length; o2++) {
        if (!opts[o2].value) continue;
        var ok = sizeAvailableForColor(opts[o2].value);
        opts[o2].disabled = !ok;
        if (!opts[o2].getAttribute('data-label')) opts[o2].setAttribute('data-label', opts[o2].textContent);
        opts[o2].textContent = ok ? opts[o2].getAttribute('data-label') : opts[o2].getAttribute('data-label') + ' (Tükendi)';
      }
      if (selected.size && !sizeAvailableForColor(selected.size)) {
        selected.size = '';
        for (var a = 0; a < sizeEls.length; a++) sizeEls[a].classList.remove('is-on');
        var sels2 = pdp.querySelectorAll('[data-size-select]');
        for (var b = 0; b < sels2.length; b++) sels2[b].value = '';
      }
    }

    function syncMediaToColor() {
      if (!selected.color) return;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.indexOf(selected.color) > -1 && variants[i].featured_image) { match = variants[i]; break; }
      }
      if (!match) return;
      var fname = baseFileName(match.featured_image.src);
      if (!fname) return;
      var imgs = pdp.querySelectorAll('[data-main-image]');
      for (var m = 0; m < imgs.length; m++) {
        if (baseFileName(imgs[m].getAttribute('data-media-src')) === fname) { showMedia(imgs[m].getAttribute('data-main-image')); return; }
      }
    }

    function sync() {
      var v = findVariant();
      var unit = v ? v.price : variants[0].price;
      var compare = v ? v.compare_at_price : variants[0].compare_at_price;
      if (priceEl) priceEl.textContent = money(unit);
      if (oldEl) { oldEl.textContent = compare > unit ? money(compare) : ''; oldEl.hidden = !(compare > unit); }
      if (saveEl) { saveEl.textContent = compare > unit ? money(compare - unit) + ' kazanç' : ''; saveEl.hidden = !(compare > unit); }
      for (var i = 0; i < totalEls.length; i++) totalEls[i].textContent = money(unit * qty());
      for (var q = 0; q < qtyDisplays.length; q++) qtyDisplays[q].textContent = qty();
      for (var j = 0; j < sizeLabels.length; j++) sizeLabels[j].textContent = selected.size || sizeLabels[j].getAttribute('data-placeholder') || 'seçiniz';
      if (idInput) idInput.value = v ? v.id : '';
      for (var k = 0; k < atc.length; k++) {
        var soldOut = v && !v.available;
        atc[k].disabled = !!soldOut;
        atc[k].textContent = soldOut ? 'Tükendi' : (atc[k].getAttribute('data-label') || 'Sepete ekle');
        if (!soldOut && atc[k].hasAttribute('data-show-total')) {
          atc[k].textContent = (atc[k].getAttribute('data-label') || 'Sepete ekle') + ' · ' + money(unit * qty());
        }
      }
    }

    function setColor(color) {
      selected.color = color;
      var sws = pdp.querySelectorAll('[data-color]');
      for (var c = 0; c < sws.length; c++) sws[c].classList.toggle('is-on', sws[c].getAttribute('data-color') === color);
      var cls = pdp.querySelectorAll('[data-color-select]');
      for (var k = 0; k < cls.length; k++) cls[k].value = color;
      for (var q = 0; q < sws.length; q++) {
        if (sws[q].getAttribute('data-color') === color) {
          var swImg = sws[q].querySelector('img');
          var thumbs = pdp.querySelectorAll('[data-color-thumb]');
          for (var t = 0; swImg && t < thumbs.length; t++) thumbs[t].src = swImg.src;
          break;
        }
      }
      var cl = pdp.querySelectorAll('[data-color-label]');
      for (var d = 0; d < cl.length; d++) cl[d].textContent = color;
      syncMediaToColor();
      updateSizeAvailability();
      sync();
    }

    function clearSizeError() {
      if (err) err.hidden = true;
    }
    function showSizeError() {
      if (err) err.hidden = false;
      var sels = pdp.querySelectorAll('[data-size-select]');
      var target = null;
      for (var s = 0; s < sels.length; s++) {
        if (!target && sels[s].offsetParent !== null) target = sels[s];
      }
      if (target) {
        if (typeof target.showPicker === 'function') {
          try { target.showPicker(); } catch (e) { target.focus(); }
        } else {
          target.focus();
        }
      }
    }

    pdp.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size]');
      if (btn && !btn.disabled) {
        selected.size = btn.getAttribute('data-size');
        var all = pdp.querySelectorAll('[data-size]');
        for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === btn);
        var sels = pdp.querySelectorAll('[data-size-select]');
        for (var s = 0; s < sels.length; s++) sels[s].value = selected.size;
        clearSizeError();
        sync();
      }
      var sw = e.target.closest('[data-color]');
      if (sw) setColor(sw.getAttribute('data-color'));
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        showMedia(thumb.getAttribute('data-thumb'));
      }
      var step = e.target.closest('[data-qty-step]');
      if (step && qtyInput) {
        qtyInput.value = Math.max(1, qty() + parseInt(step.getAttribute('data-qty-step'), 10));
        sync();
      }
      var guide = e.target.closest('[data-guide-toggle]');
      if (guide) {
        var panel = pdp.querySelector('[data-guide]');
        if (panel) panel.hidden = !panel.hidden;
      }
      var tab = e.target.closest('[data-tab]');
      if (tab) {
        var name = tab.getAttribute('data-tab');
        var tabs = pdp.querySelectorAll('[data-tab]');
        for (var x = 0; x < tabs.length; x++) {
          var on = tabs[x] === tab;
          tabs[x].classList.toggle('is-on', on);
          tabs[x].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        var panels = pdp.querySelectorAll('[data-tabpanel]');
        for (var y = 0; y < panels.length; y++) panels[y].hidden = panels[y].getAttribute('data-tabpanel') !== name;
      }
    });

    pdp.addEventListener('change', function (e) {
      var colorSel = e.target.closest('[data-color-select]');
      if (colorSel) setColor(colorSel.value);
      var sel = e.target.closest('[data-size-select]');
      if (sel) {
        selected.size = sel.value;
        var btns = pdp.querySelectorAll('[data-size]');
        for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-on', btns[i].getAttribute('data-size') === selected.size);
        var sels = pdp.querySelectorAll('[data-size-select]');
        for (var s = 0; s < sels.length; s++) sels[s].value = selected.size;
        clearSizeError();
        sync();
      }
      if (e.target.closest('[data-qty]')) sync();
    });

    /* add to cart (AJAX) */
    var forms = pdp.querySelectorAll('form[action*="/cart/add"]');
    for (var fi = 0; fi < forms.length; fi++) {
      forms[fi].addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (!v) { showSizeError(); return; }
        drawer.add(v.id, qty());
      });
    }

    /* sticky bar reveal (desktop) */
    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky) {
      window.addEventListener('scroll', function () {
        var on = window.scrollY > 700;
        sticky.classList.toggle('is-on', on);
        document.body.classList.toggle('zz-sticky-buy-open', on);
      }, { passive: true });
    }

    /* ships-today countdown (Turkey time, Europe/Istanbul) */
    var cutoffEls = pdp.querySelectorAll('[data-cutoff]');
    if (cutoffEls.length) {
      var hour = parseInt(cutoffEls[0].getAttribute('data-cutoff') || '12', 10);
      var labelEls = pdp.querySelectorAll('[data-ship-label]');
      var timerWraps = pdp.querySelectorAll('[data-ship-timer-wrap]');

      var istanbulNow = function () {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Istanbul', hour12: false,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
        var parts = {};
        fmt.formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') parts[p.type] = p.value; });
        if (parts.hour === '24') parts.hour = '00';
        return new Date(parts.year + '-' + parts.month + '-' + parts.day + 'T' + parts.hour + ':' + parts.minute + ':' + parts.second);
      };

      var tick = function () {
        var now = istanbulNow();
        var day = now.getDay(); /* 0 = Sunday, 6 = Saturday */
        var cutoffToday = new Date(now); cutoffToday.setHours(hour, 0, 0, 0);
        var mode, target;
        if (day === 0) {
          mode = 'monday';
        } else if (now < cutoffToday) {
          mode = 'today'; target = cutoffToday;
        } else if (day === 6) {
          mode = 'monday'; /* Saturday after cutoff: Sunday has no shipping, so next is Monday */
        } else {
          mode = 'tomorrow';
        }

        var label = mode === 'today' ? 'Bugün kargoda' : (mode === 'tomorrow' ? 'Yarın kargoda' : 'Pazartesi kargoda');
        for (var l = 0; l < labelEls.length; l++) labelEls[l].textContent = label;
        for (var w = 0; w < timerWraps.length; w++) timerWraps[w].hidden = mode !== 'today';

        if (mode === 'today') {
          var d = Math.floor((target - now) / 1000);
          var p = function (n) { return String(n).padStart(2, '0'); };
          var txt = p(Math.floor(d / 3600)) + ':' + p(Math.floor(d / 60) % 60) + ':' + p(d % 60);
          for (var i = 0; i < cutoffEls.length; i++) cutoffEls[i].textContent = txt;
        }
      };
      tick(); setInterval(tick, 1000);
    }

    syncMediaToColor();
    updateSizeAvailability();
    sync();
  });

  /* ---------- sticky support button ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var supp = document.querySelector('[data-support]');
    if (!supp) return;
    var toggle = supp.querySelector('[data-support-toggle]');
    document.addEventListener('click', function (e) {
      if (toggle.contains(e.target)) {
        supp.classList.toggle('is-open');
        return;
      }
      if (!supp.contains(e.target)) supp.classList.remove('is-open');
    });
  });

  /* ---------- generic campaign countdown ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-countdown-to]');
    if (!els.length) return;
    var tick = function () {
      for (var i = 0; i < els.length; i++) {
        var target = new Date(els[i].getAttribute('data-countdown-to')).getTime();
        var left = Math.max(0, target - Date.now());
        var p = function (n) { return String(n).padStart(2, '0'); };
        var days = Math.floor(left / 86400000);
        els[i].textContent = (days > 0 ? days + 'g ' : '') +
          p(Math.floor(left / 3600000) % 24) + ':' + p(Math.floor(left / 60000) % 60) + ':' + p(Math.floor(left / 1000) % 60);
      }
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- collection: native Shopify filters + sort + load more ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-collection]');
    if (!root) return;
    var sortSel = root.querySelector('[data-sort]');
    if (sortSel) sortSel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var stock = root.querySelector('[data-stock-filter]');
    if (stock) stock.addEventListener('change', function () {
      window.location.href = stock.checked ? stock.getAttribute('data-url-on') : stock.getAttribute('data-url-off');
    });

    var grid = root.querySelector('[data-collection-grid]');
    var more = root.querySelector('[data-load-more]');
    var label = root.querySelector('[data-shown-label]');
    var fill = root.querySelector('[data-shown-fill]');
    var total = parseInt(root.getAttribute('data-total') || '0', 10);
    function update() {
      var n = grid.querySelectorAll('[data-product-card]').length;
      if (label) label.textContent = n + ' / ' + total + ' ürün görüntüleniyor';
      if (fill) fill.style.width = (total ? (n / total) * 100 : 0) + '%';
    }
    if (more) more.addEventListener('click', function () {
      var next = more.getAttribute('data-next');
      if (!next) return;
      more.disabled = true; more.textContent = 'Yükleniyor…';
      fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-collection-grid] [data-product-card]');
        for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
        var nb = doc.querySelector('[data-load-more]');
        var n = nb ? nb.getAttribute('data-next') : '';
        if (n) { more.setAttribute('data-next', n); more.disabled = false; more.textContent = 'Daha fazla ürün'; }
        else more.hidden = true;
        update();
      });
    });
    update();
  });
})();
